import PlatformActions from './PlatformActions'

export default class THREEOAKSActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'SLOT',
      gameName: 'Sun of Egypt',
      gameCode: '3OAKS-SLOT-005',
      platform: 'THREEOAKS',
    }
  }

  getBetNSettleMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betTime,
      betAmount,
      turnover,
      winAmount,
      jackpotWinAmount,
      updateTime,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: txnId, // 9a1450a7f8b54c14822c1c1173e55f42
      roundId, // 1783481655638001
      betType: null,
      currency,
      betTime, // 2026-07-08T11:34:15.000+08:00
      txTime: betTime,
      betAmount,
      turnover,
      winAmount,
      jackpotBetAmount: 0,
      jackpotWinAmount: jackpotWinAmount ?? 0,
      updateTime, // 2026-07-08T11:34:16.177+08:00
      requireAmount: betAmount,
      gameInfo: {
        roundFinished: true,
        roundStarted: true,
        action: 'spin',
      },
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'betNSettle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetNSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betAmount,
      updateTime,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: txnId,
      roundId,
      updateTime,
      betAmount,
      gameInfo: {
        roundFinished: true,
        roundStarted: true,
        action: 'spin',
      },
    }))

    const message = {
      action: 'cancelBetNSettle',
      txns,
    }

    return JSON.stringify(message)
  }
}
